import type { Modal } from '@/components/ModalManager/types';
import { ModalIds } from '@/components/ModalManager/types';

export enum ToastTheme {
  Danger = 'danger',
  Success = 'success',
  Warning = 'warning',
  Info = 'info',
}

export interface Toast {
  isOpen: boolean;
  title: string;
  theme: ToastTheme;
  message: string;
}

export interface AppState {
  toast: Toast;
  modals: Modal[];
}

export function getInitialAppState(): AppState {
  return {
    toast: {} as Toast,
    modals: [
      { id: ModalIds.AgencySwitcherModal, isOpen: false },
      { id: ModalIds.NoActiveAgencyModal, isOpen: false },
      { id: ModalIds.MfaConfirmationModal, isOpen: false },
      { id: ModalIds.GotMandateModal, isOpen: false },
      { id: ModalIds.NotGotMandateModal, isOpen: false },
      { id: ModalIds.NotSoldModal, isOpen: false },
      { id: ModalIds.PropertySoldModal, isOpen: false },
      { id: ModalIds.ExportCsvModal, isOpen: false },
      { id: ModalIds.ResetMfaModal, isOpen: false },
      { id: ModalIds.ToplistingModal, isOpen: false },
      { id: ModalIds.RegionalHighlightPurchaseModal, isOpen: false },
    ],
  };
}
